import src from "IMAGE";
export default { src, width: 107, height: 40, blurWidth: 0, blurHeight: 0};
